const isObject = <T extends Record<string, unknown> = Record<string, unknown>>(value: unknown): value is T => !!value && typeof value === 'object' && value.toString() === '[object Object]';

export default isObject;
